module.exports = __webpack_public_path__ + "static/img/logo2.2835ac4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo2.png
// module id = jgZB
// module chunks = 1